import Vue from 'vue';

const uuid = () => {
  const uuidPattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  let time = new Date().getTime();
  let uuid = uuidPattern.replace(/[xy]/g, c => {
    const r = (time + Math.random() * 16) % 16 | 0;
    time = Math.floor(time / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });

  uuid = `id-${uuid}`;

  return uuid;
};

Vue.prototype.$uuid = uuid;

export default uuid;
